<template>
  <Dialog title="message.leaveUnsave" :open="showDialog" enableCancel @close="_dialogAction">
    <template #content>{{ $t('message.leaveUnsaveMsg') }}</template>
  </Dialog>
</template>

<script>
import Dialog from '@/components/layout/DialogLayout.vue'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ConfirmLeaveDialog',
  components: {
    Dialog,
  },
  computed: {
    ...mapState({
      toLink: state => state.leaveDialog.toLink,
    }),
    showDialog() {
      return this.$store.state.leaveDialog.showDialog
    },
  },
  data: () => ({}),
  methods: {
    ...mapActions(['hideLeaveDialog'], 'leaveDialog'),
    async _dialogAction(action) {
      if (action === true) {
        if (this.toLink) {
          await this.$store.dispatch('setDataIsUpdated', false)
          this.$router.replace(this.toLink)
          this.hideLeaveDialog()
        }
      } else {
        this.hideLeaveDialog()
      }
    },
  },
}
</script>
